const state = {
  token: '',
  sales_flag: false,
}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js